/**
 * Series Marker 선택 Modal 관련 기능 구현
 *   - Modal Open
 *   - 확인 클릭시 처리
 */

import { _ } from 'core-js'
import BriqueChart from './BriqueChart'

// import BriqueChart from './BriqueChart.vue'
// import { ToastProgrammatic as Toast } from 'buefy'

export default {
  /**
   * Marker 선택 모달 대화 상자의 데이터를 세팅한다.
   * @param {Object} element Chart Element
   * @param {String} seriesName Series Name
   */
  openChartModalMarker (element, seriesName) {
    element.parentElement.__vue__.chartModalMarker.visible = true
    element.parentElement.__vue__.chartModalMarker.chartData = element.briqueChartData.tracesOriginal
    element.parentElement.__vue__.chartModalMarker.seriesName = seriesName
    element.parentElement.__vue__.chartModalMarker.beforeSymbol = element.briqueChartData.getSeriesMarkerSymbol(element, seriesName)
    element.parentElement.__vue__.chartModalMarker.beforeSize = element.briqueChartData.getSeriesMarkerSize(element, seriesName)
  },

  /**
     * Marker 선택 차트 모달에서 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     * @param {Object} chartVue Chart Vuew Object
     * @param {String} seriesName Series Name
     * @param {Object} data 선택된 데이터
     */
  onClickConfirmButtonInModalMarker (returnObject, chartVue, seriesName, data) {
    let element = chartVue.$el.children[0]
    let seriesStyle = element.briqueChartData.getSeriesStyle(seriesName)

    if (_.isEmpty(data.symbol) || data.symbol === 'none') {
      element.briqueChartData.setSeriesStyle(seriesName, { mode: seriesStyle.mode.replace(/\+?markers$/, '').replace(/^markers\+?/, '') })
      if (!seriesStyle.mode.includes('lines')) element.briqueChartData.setSeriesStyle(seriesName, { mode: `${seriesStyle.mode}+lines` }) // 연결선 표시

      BriqueChart.react(element, element.data)
    } else {
      if (_.isEmpty(seriesStyle.marker)) seriesStyle.marker = {}
      if (!seriesStyle.mode.includes('markers')) {
        element.briqueChartData.setSeriesStyle(seriesName, { mode: `${seriesStyle.mode}+markers` })
      }
      element.briqueChartData.setSeriesStyle(seriesName, { marker: { symbol: data.symbol, size: data.size } })
    }

    BriqueChart.react(element, element.data)
  }

}
